// 之前的样式的组件 
// import MainPage from '../mainpage/mainpage.vue'

import MainPage from '../../components/mainpage/mainpage.vue'

export default {
	props: ['titleText'],
	data() {
		return {
			//协议弹出框
			outerVisible: false,
			//手机号登录默认变量
			activeName: 'first',
			//获取手机验证码返回的guid
			guid: '',
			//用来判断弹出的登录注册框=>登录/注册
			isEnter: true,
			//搜索课程的字符串
			classSreach: '',
			//登录提示
			loginMessage: '',
			//是否需要登录提示
			isLoginMessage: false,
			//身份证登录提示
			loginMessage1: '',
			//身份证是否需要登录提示
			isLoginMessage1: false,
			//登录手机号
			loginPhone: '',
			//登录身份证号
			loginIdentity: '',
			//登录密码
			loginPassword: '',
			//注册提示
			registerMessage: '',
			//是否需要注册提示
			isRegisterMessage: false,
			//注册手机号
			registerPhone: '',
			//注册验证码
			registerCode: '',
			//注册密码
			registerPassword: '',
			//确认注册密码
			registerAffirmPassword: '',
			//身份证号码
			idcard: '',
			//获取验证码文字
			verificationText: '获取验证码',
			//用来存储多级标签
			labels: {
				id: '0'
			},
			//传标签JSON，但是没有除开一级标签
			labelsNoFirst: [],
			//同意协议
			agreeDoc: '',
			// 是否需要购物车
			is_project: '',
			// 是否显示站内信
			showMessage: false,
			// 站内信数组
			messageList: [],
			// 站内信消息数量
			messageNum: 0,
			// 未读的站内信消息数量
			unreadMessagesNum: 0
		}
	},
	methods: {
		//点击导航栏登录/注册切换弹出的登录/注册
		displayEnter: function(val) {
			this.isEnter = val;
		},
		// enter键登录
		loginKeyDown: function(e) {
			if (e.key === 'Enter') {
				this.login();
			}
		},
		// enter身份证登录按键
		loginKeyDown1: function(e) {
			if (e.key === 'Enter') {
				this.login1();
			}
		},
		// enter键注册
		registerKeyDown: function(e) {
			if (e.key === 'Enter') {
				this.register();
			}
		},
		//enter键搜索课程
		searchKeyDown: function(e) {
			if (e.key === 'Enter') {
				this.toProductList();
			}
		},
		//切换登录/注册
		switchEnter: function() {
			this.isEnter = !this.isEnter;
		},
		//获取当前路由的path
		getRouterPath() {
			//获取当前网址
			let arr = window.location.href.split('/');
			//分割成数组并取最后一个
			let str = arr[arr.length - 1];
			//定义path
			let path = "";
			//若str为空，则肯定是首页
			if (str == "") {
				path = "/"
			} else {
				//不为空则再判断是否有?传参，有则去掉传参的字符，无则直接获取
				str.indexOf("?") == -1 ? path = str : path = str.split("?")[0];
			}
			return path;
		},
		//课程搜索
		toProductList: function() {
			if (this.classSreach == '') {
				UIkit.modal(document.querySelector('#modal-search-tips')).show();
				return;
			} else {
				this.$router.push({
					path: '/blank',
					query: {
						data: this.classSreach,
						value: 'classtext',
					}
				});
			}


		},
		//跳转首页
		goIndex: function() {
			this.$router.push({
				path: '/'
			})
		},
		//跳转个人中心
		toCenter: function() {
			
			if (this.$store.state.my_style == 0) {
				this.$router.push({
					path: '/personalcenter'
				});
			}else if(this.$store.state.my_style == 1){
				this.$router.push({
					path: '/personalcenter1'
				});
			}else if(this.$store.state.my_style == 2){
				this.$router.push({
					path: '/personalcenter2'
				});
			}
			// window.open(address.href,'_blank');
		},
		//跳转购物车
		toShoppingCart: function() {
			this.$router.push({
				path: '/shoppingcart'
			})
		},
		//全部课程跳转
		allClass: function() {
			this.$router.push({
				path: '/blank',
				query: {
					zerotId: 0,
					lableType: 'zeroLable',
				}
			})
		},
		//推荐课程
		recommendClass: function() {
			this.$router.push({
				path: '/blank',
				query: {
					firstId: 31,
					secondId: 12,
					lableType: 'secondLable'

				}
			});
		},
		//继续教育课程
		continuingEducation: function() {
			this.$router.push({
				path: '/blank',
				query: {
					firstId: 31,
					lableType: 'firstLable',
				}
			});
		},
		//登录
		login: function() {
			let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
			let me = this;
			if (!me.loginPhone.trim()) {
				me.loginMessage = '手机号不能为空';
				me.isLoginMessage = true;
			} else if (!reg.test(me.loginPhone)) {
				me.loginMessage = '手机号格式错误';
				me.isLoginMessage = true;
			} else if (!me.loginPassword.trim()) {
				me.loginMessage = '密码不能为空';
				me.isLoginMessage = true;
			} else {
				// // console.log(this.$store.state.store.id);
				let obj = {
					phone: me.loginPhone,
					password: me.loginPassword,
					shop_id: this.$store.state.store.id
				}
				me.$post('users/login', obj).then(res => {
					if (res.data.result) {
						me.$store.state.id = res.data.result.token;
						me.$store.state.shopId = res.data.result.shop_id
						let model = document.querySelector('#modal-center');
						UIkit.modal(model).hide();
						this.$post('users/profile', {
							token: this.$store.state.id
						}).then(res => {

							me.$store.state.userId = res.data.result.id;
							me.$store.state.name = res.data.result.name;
							me.$store.state.my_style = res.data.result.my_style;

							// 用户登录成功，显示站内信图标并获取数据
							this.showMessage = true
							this.getMessage()

							// 将用户id存到缓存中
							sessionStorage.setItem('userid', this.$store.state.userId)
							sessionStorage.setItem("tpid", this.$store.state.id);
							sessionStorage.setItem("tpname", this.$store.state.name);
							sessionStorage.setItem('tpuserId', this.$store.state.userId);
							sessionStorage.setItem('tpshopid', this.$store.state.shopId);
						}).then(() => {
							this.$post("shopping_cart/search", {
								token: this.$store.state.id,
								offset: "0",
								length: 9999,
								shop_id: this.$store.state.store.id
							}).then(res => {
								this.$store.state.shopNum = res.data.result.data.length;

								if (this.$route.path == '/' && this.$store.state.newsId != undefined) {
									// // console.log(this.$store.state.newsId,this.$store.state.newsType,this.$store.state.newsIndex)
									this.$router.push({
										path: '/projectnews',
										query: {
											id: this.$store.state.newsId,
											type: this.$store.state.newsType,
											index: this.$store.state.newsIndex
										}
									})
								} else {
									if (me.$store.state.my_style == 0) {
										this.$router.push({
											path: '/personalcenter',

										})
									} else if (me.$store.state.my_style == 1) {
										this.$router.push({
											path: '/personalcenter1',

										})
									} else if (me.$store.state.my_style == 2) {
										this.$router.push({
											path: '/personalcenter2',

										})
									}

								}

							});
						});
					} else if (res.data.errorMsg === '用户名或密码错误') {
						me.loginMessage = '手机号或密码错误';
						me.isLoginMessage = true;
					}
				})
			}
		},
		//身份证登录
		login1: function() {
			let reg = /^\d{17}(\d|X|x)$/;
			let me = this;
			if (!me.loginIdentity.trim()) {
				me.loginMessage1 = '身份证号不能为空';
				me.isLoginMessage1 = true;
			} else if (!reg.test(me.loginIdentity)) {
				me.loginMessage1 = '身份证号格式错误';
				me.isLoginMessage1 = true;
			} else if (!me.loginPassword.trim()) {
				me.loginMessage1 = '密码不能为空';
				me.isLoginMessage1 = true;
			} else {
				let obj = {
					idcard: me.loginIdentity,
					password: me.loginPassword,
					shop_id: me.$store.state.store.id
				}
				me.$post('users/login_by_idcard', obj).then(res => {
					if (res.data.result) {
						me.$store.state.id = res.data.result.token;
						me.$store.state.shopId = res.data.result.shop_id
						let model = document.querySelector('#modal-center');
						UIkit.modal(model).hide();
						this.$post('users/profile', {
							token: this.$store.state.id
						}).then(res => {
							me.$store.state.userId = res.data.result.id;
							me.$store.state.name = res.data.result.name;
							me.$store.state.my_style = res.data.result.my_style;

							// 用户登录成功，显示站内信图标并获取数据
							this.showMessage = true
							this.getMessage()

							sessionStorage.setItem("tpid", this.$store.state.id);
							sessionStorage.setItem("tpname", this.$store.state.name);
							sessionStorage.setItem('tpuserId', this.$store.state.userId);
							sessionStorage.setItem('tpshopid', this.$store.state.shopId);
						}).then(() => {
							this.$post("shopping_cart/search", {
								token: this.$store.state.id,
								offset: "0",
								length: 9999,
								shop_id: this.$store.state.store.id
							}).then(res => {
								this.$store.state.shopNum = res.data.result.data.length;
								if (me.$store.state.my_style == 0) {
									this.$router.push({
										path: '/personalcenter',

									})
								} else if (me.$store.state.my_style == 1) {
									this.$router.push({
										path: '/personalcenter1',

									})
								} else if (me.$store.state.my_style == 2) {
									this.$router.push({
										path: '/personalcenter2',

									})
								}
							});
						});
					} else if (res.data.errorMsg === '用户名或密码错误') {
						me.loginMessage1 = '身份证号或密码错误';
						me.isLoginMessage1 = true;
					}
				})
			}
		},
		//跳转去忘记密码页面
		wangjimima: function() {
			let model = document.querySelector('#modal-center');
			UIkit.modal(model).hide();
			this.$router.push({
				path: '/forgetpassword'
			});
		},
		//跳转去我的订单
		toMyOrder: function() {
			this.$router.push({
				path: '/myorder'
			});
		},
		//退出登录
		loginOut: function() {
			sessionStorage.removeItem("tpid");
			sessionStorage.removeItem("tpname");
			sessionStorage.removeItem("tpuserId");
			sessionStorage.removeItem("tpshopid");
			this.$store.state.id = null;
			this.$store.state.shopNum = 0;
			this.$store.state.userId = null;
			this.$router.push({
				path: '/'
			})
		},
		//登录时手机号输入框失去焦点
		loginPhoneBlur: function() {
			let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
			let me = this;
			if (me.loginPhone.trim()) {
				if (reg.test(me.loginPhone)) {
					me.isLoginMessage = false;
				} else {
					me.loginMessage = '手机号格式错误',
						me.isLoginMessage = true;
				}
			}
		},
		//登录时手机号输入框获取焦点
		loginPhoneFocus: function() {
			if (this.loginMessage === '手机号不能为空' || this.loginMessage === '手机号格式错误' || this.loginMessage === '手机号或密码错误') {
				this.isLoginMessage = false;
			}
		},
		//登录时密码框获取焦点
		loginPasswordFocus: function() {
			if (this.loginMessage === '密码不能为空' || this.loginMessage === '手机号或密码错误') {
				this.isLoginMessage = false;
			}
		},
		//注册
		register: function() {
			if (this.$store.state.store.agreement != '' && String(this.$store.state.store.agreement) != 'undefined' && String(
					this.$store.state.store.agreement) != 'null') {
				if (this.agreeDoc != true) {
					alert('必须同意用户协议才可注册!');
					return false;
				}
			}

			let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
			let idcardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
			let me = this;
			if (!me.registerPhone.trim()) {
				me.registerMessage = '手机号不能为空';
				me.isRegisterMessage = true;
			} else if (!reg.test(me.registerPhone)) {
				me.registerMessage = '手机号格式错误';
				me.isRegisterMessage = true;
			} else if (!me.registerCode.trim()) {
				me.registerMessage = '验证码不能为空';
				me.isRegisterMessage = true;
			} else if (!me.idcard.trim()) {
				me.registerMessage = '身份证不能为空';
				me.isRegisterMessage = true;
			} else if (!idcardReg.test(me.idcard) || me.idcard.length !== 18) {
				me.registerMessage = '身份证格式错误';
				me.isRegisterMessage = true;
			} else if (!me.registerPassword.trim()) {
				me.registerMessage = '密码不能为空';
				me.isRegisterMessage = true;
			} else if (!me.registerAffirmPassword.trim()) {
				me.registerMessage = '确认密码不能为空';
				me.isRegisterMessage = true;
			} else if (me.registerPassword.trim() !== me.registerAffirmPassword.trim()) {
				me.registerMessage = '两次密码不匹配';
				me.isRegisterMessage = true;
			} else {
				let obj = {
					phone: this.registerPhone,
					password: this.registerPassword,
					idcard: this.idcard,
					code: this.registerCode,
					guid: this.guid,
					shop_id: this.$store.state.store.id
				}
				this.$post('users/register', obj).then(res => {
					if (res.data.result == '') {
						let model = document.querySelector('#modal-center');
						UIkit.modal(model).hide();
						let modeltwo = document.querySelector('#modal-success-zhuce');
						UIkit.modal(modeltwo).show();
					} else if (res.data.result == '该用户已注册') {
						this.registerMessage = '该用户已注册';
						this.isRegisterMessage = true;
					} else if (res.data.result == '验证码错误') {
						this.registerMessage = '验证码错误';
						this.isRegisterMessage = true;
					}
				})
			}
		},
		//注册时手机号输入框失去焦点
		registerPhoneBlur: function() {
			let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
			let me = this;
			if (me.registerPhone.trim()) {
				if (reg.test(me.registerPhone)) {
					me.isRegisterMessage = false;
				} else {
					me.registerMessage = '手机号格式错误',
						me.isRegisterMessage = true;
				}
			}
		},
		//注册时手机号输入框获取焦点
		registerPhoneFocus: function() {
			if (this.registerMessage === '手机号不能为空' || this.registerMessage === '手机号格式错误' || this.registerMessage === '该用户已注册') {
				this.isRegisterMessage = false;
			}
		},
		//注册身份证号输入框获取焦点
		registerIdFocus: function() {
			if (this.registerMessage === '身份证不能为空' || this.registerMessage === '该用户已注册' || this.registerMessage === '身份证格式错误') {
				this.isRegisterMessage = false;
			}
		},
		//注册时验证码框获取焦点
		registerCodeFocus: function() {
			if (this.registerMessage === '验证码错误') {
				this.isRegisterMessage = false;
			}
		},
		//获取手机验证码
		getVerificationCode: function() {
			let me = this;
			let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
			if (me.registerPhone.trim() == '') {
				this.registerMessage = '手机号不能为空';
				this.isRegisterMessage = true;
				return;
			} else if (!reg.test(me.registerPhone)) {
				me.registerMessage = '手机号格式错误';
				me.isRegisterMessage = true;
				return;
			} else {
				if (me.verificationText === '获取验证码') {
					this.$post('users/sms_send', {
						phone: this.registerPhone
					}).then(res => {
						this.guid = res.data.result;
					})
					let time = 60;
					let timego = setInterval(function() {
						me.verificationText = time + '秒后重发';
						--time;
						if (time < 0) {
							clearInterval(timego);
							me.verificationText = '获取验证码';
						}
					}, 1000);
				}
			}
		},
		//注册时密码框获取焦点
		registerPasswordFocus: function() {
			if (this.registerMessage === '密码不能为空' || this.registerMessage === '两次密码不匹配') {
				this.isRegisterMessage = false;
			}
		},
		//注册时密码框获取焦点
		registerAffirmPasswordFocus: function() {
			if (this.registerMessage === '确认密码不能为空' || this.registerMessage === '两次密码不匹配') {
				this.isRegisterMessage = false;
			}
		},
		// 获取店铺信息
		getShopInfo() {
			this.$post('shops/get_shopid', {
				id: this.$store.state.store.id
			}).then(res => {
				if (res.status === 200) {
					this.is_project = res.data.result.is_project
				}
			})
		},

		// 获取站内信信息
		getMessage() {
			// 发送请求获取站内信信息
			this.$post('message/search', {
				token: this.$store.state.id,
				user_id: this.$store.state.id,
				offset: 0,
				length: 10
			}).then(res => {
				this.messageList = res.data.result.data
				this.readMessageList = this.messageList.filter(item => item.status == 1)
				this.messageNum = res.data.result.total

				// 计算未读的站内信消息
				let unreadMessagesNum = 0
				this.messageList.map(item => {
					if (item.status == 0) {
						unreadMessagesNum++
					}
				})
				this.unreadMessagesNum = unreadMessagesNum
			})
		},

		// 将某则站内信标记为已读
		markRead(message) {
			this.$post('message/update', {
				token: this.$store.state.id,
				id: message.id,
				status: 1
			}).then(res => {
				this.$message({
					type: 'success',
					message: '已标记为已读'
				})
				this.getMessage()
			})
		}
	},
	//DOM加载完毕执行
	mounted: function() {
		let model = document.querySelector('#modal-example-1');
		let me = this;
		UIkit.util.on(model, 'hidden', function() {
			me.toLogin();
		});
	},

	created() {
		this.getShopInfo()

		// 如果用户登录了，则显示站内信图标并获取当前用户的站内信信息
		if (sessionStorage.getItem('tpid')) {
			this.showMessage = true
			this.getMessage()
		}
	},

	components: {
		MainPage,
	}
}
